/** Invoices entry in the portal menu (wording kept with the module). */
export const BILLING_NAV = { label: "Invoices", hint: "Dockets to invoice, payments" } as const;
